<template style="height:100%,width:100%">
  <div class="Outdata CommonContentSingle-gray">
    <el-container>
    <el-header v-bind:class="[isActive ? activeClass : errorClass]">
      <el-form :inline="true" :model="formInline">
        <el-form-item v-model="formInline.PaperCode" :label="$t('original.languages151')">
          <el-cascader  ref="wcascader"  :placeholder="$t('original.languages151')" filterable @change="bumen"  :options="options" :props="{ checkStrictly: true }"></el-cascader>
        </el-form-item>
        <el-form-item :label="$t('original.Release_theme')">
          <el-select  @change="schange"  v-model="formInline.PublishID"  :placeholder="$t('original.Release_theme')">
            <el-option  v-for="item in PublishSubject" :key="item.id"  :label="item.PublishSubject" :value="item.PublishID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('original.Release_object')">
          <el-select v-model="formInline.DeptID" :placeholder="$t('original.Release_object')" filterable>
            <el-option v-for="item in obj" :key="item.id" :label="item.DeptName" :value="item.DeptID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="测试时间">
          <el-date-picker  v-model="formInline.Time" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item class="cvde" :label="$t('original.languages144')">
          <div style="display: flex;">
            <div style="margin-right: 0px;">
              <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange">
                全选
              </el-checkbox>
            </div>
            <el-checkbox-group v-model="formInline.ResultID" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="(item, index) in statusTree" :key="index" :value="item.id" :label="item.id">
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>

        <el-form-item class="cvde2" :label="$t('original.languages154')">
          <div style="display: flex;">
            <div style="margin-right: 0px;">
              <el-checkbox :disabled="disableds" v-model="checkAll2" :indeterminate="isIndeterminate2" @change="handleCheckAllChange2">
                {{ $t('original.languages155') }}
              </el-checkbox>
            </div>
            <el-checkbox-group v-model="formInline.WarningID" @change="handleCheckedCitiesChange2">
              <el-checkbox :disabled="disableds" v-for="(item, index) in statusTree2" :key="index" :value="item.id" :label="item.id">
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>

        <br />
        <el-form-item class="cvbb" style="width: 260px;">
          <el-button type="primary" @click="onSubmit">{{ $t('original.screening') }}</el-button>
          <el-button type="primary" @click="resets">{{ $t('original.reset') }}</el-button>
        </el-form-item>
        <!-- <div class="change" @click="change">打开</div> -->
      </el-form>

    </el-header>
    
    <el-main class="Thelist">
      <el-button type="primary" :disabled="disableds" @click="onSubmits" style="margin-bottom:10px;">{{$t('original.Export_data')}}</el-button>

      <el-table v-loading="loadings" :data="tableData" style="width: 100%;">
        
        <el-table-column v-if="serialnumber" label="序号" width="60px" align="center">
          <template slot-scope="scope" center>
            {{ (currentPage1 - 1) * 10 + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column v-for="(item, key, index) in tableData[0]" :key="index" :label="key" v-if="key != 'PaperResultID' && key != 'WarningcolorSS'"
          :min-width="key == '量表名称' ? '300' : ''">

          <template slot-scope="scope">
            <div v-if="key != '预警结果111'">
              <span>{{ scope.row[key] }}</span>
            </div>

            <div v-else>
              <div v-if="scope.row[key] != ''" :style="{float:'left','margin-right':'10px','margin-top':'3.5px','background-color':scope.row['warningcolorSS'], width: '54px',height: '24px','border-radius': '5px','text-align': 'center', color: '#fff',}">
                <div v-if="scope.row[key] != ''">{{ scope.row[key] }}</div>
              </div>
              <div v-else>-</div>
              <!-- <div style="float:left;" v-if="scope.row[key] != ''">{{scope.row[key]}}</div> -->
            </div>

          </template>
        </el-table-column>
      </el-table>

      <div class="block" v-if="tableData.length > 0">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1" :page-size="10" layout="total, prev, pager, next,jumper" :total="Counts"></el-pagination>
      </div>

    </el-main>
   </el-container>
  </div>
</template>
<script>
import Notest from './Notest'
export default {
  data() {
    return {
      xaxa:'',
      serialnumber: false,
      disableds: true,
      isIndeterminate: false,
      isIndeterminate2: false,
      checkAll: false,
      checkAll2: false,
      statusTree: [
        {
          id: '重度',
          label: '重度',
        },
        {
          id: '较重',
          label: '较重',
        },
        {
          id: '中度',
          label: '中度',
        },
        {
          id: '轻度',
          label: '轻度',
        },
        {
          id: '正常',
          label: '正常',
        },
      ],
      statusTree2: [
        {
          id: '量表原始分',
          label: '量表原始分',
        },
        {
          id: '量表标准分',
          label: '量表标准分',
        },
        {
          id: '量表平均分',
          label: '量表平均分',
        },
        {
          id: '因子平均分',
          label: '因子平均分',
        },
        {
          id: '题目答案',
          label: '题目答案',
        },
        {
          id: '因子原始分',
          label: '因子原始分',
        },
        {
          id: '因子标准分',
          label: '因子标准分',
        },
      ],
      loadings: false,
      activeName: 'second',
      PublishSubject: [],
      currentPage1: 1,
      Counts: 0,
      input1: '',
      value1: '',
      // isIndeterminate: true,
      obj: '',
      isActive: true,
      activeClass: 'Nac',
      errorClass: 'Nac2',
      formInline: {
        DeptID: '',
        PublishID: '',
        ResultID: [],
        Time: [],
        WarningID: [],
        PaperCode: '',
      },
      tableData: [],
      options: [],
    }
  },
  components: {
    Notest,
  },
  methods: {
    handleChange(val) {},
    // formtype(row, column, cellValue){
    //   if (cellValue == "正常"){
    //       return '广域网';
    //     }else if (cellValue == 2){
    //       return '局域网';
    //    }
    // },

    change() {
      this.isActive = !this.isActive
    },
    onSubmit() {
      this.serialnumber = false;
      this.loading(1, 0)
      this.tableData = []
    },
    onSubmits() {
      this.loadings = true
      this.$Http_Post('ScaleIssue/GetPrimaryData', {
        from: this.formInline,
        pageSize: '10',
        pageIndex: 1,
        Yesno: '1',
        Language: 'Chinese',
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.loadings = false
          window.location = res.Data
        } else {
          this.Global.request_failure(res.Message)
        }
      })
    },
    resets() {
      // PaperCode
      this.formInline.DeptID = '';
      this.formInline.PublishID = this.xaxa;

      this.formInline.ResultID = [];
      this.formInline.Time = [];
      this.formInline.WarningID = [];
      this.$refs.wcascader.$refs.panel.checkedValue = [];
      this.isIndeterminate = false;
      this.isIndeterminate2 = false;
      this.checkAll2 = false;
      this.checkAll = false;
      this.disableds = true;
      this.formInline.PaperCode = '';
      this.loading(1, 0);
      this.currentPage1 = 1;
    },
    handleCurrentChange(val) {
      this.loading(val, 0)
      this.tableData = []
    },
    bumen(val) {
      if (val.length > 0) {
        this.formInline.PaperCode = val[val.length - 1];
        this.$refs.wcascader.dropDownVisible = false;
        this.disableds = false;
      }
    },
    schange(val) {
      this.formInline.DeptID = '';
      this.formInline.obj = '';
      this.$Http_Post('ScaleIssue/GetCommonReturnDataTheme', {PublishID: val}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.obj = res.Data;
        }
      })
    },
    handleCheckAllChange(val) {
      const all = this.statusTree.map((item) => {
        return item.id
      })
      this.formInline.ResultID = val ? all : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length;
      this.checkAll = checkedCount === this.statusTree.length;
      this.isIndeterminate == checkedCount > 0 && checkedCount < this.statusTree.length;
    },
    //////////////////////////////////////////
    
    handleCheckAllChange2(val) {
      const all = this.statusTree2.map((item) => {
        return item.id
      })
      this.formInline.WarningID = val ? all : []
      this.isIndeterminate2 = false
    },
    handleCheckedCitiesChange2(value) {
      const checkedCount = value.length;
      this.checkAll2 = checkedCount === this.statusTree2.length;
      this.isIndeterminate2 = checkedCount > 0 && checkedCount < this.statusTree2.length;
    },
    loading(num, Yesno) {
      this.loadings = true;
      this.$Http_Post('ScaleIssue/GetPrimaryData', {from: this.formInline,pageSize: '10',pageIndex: num,Yesno: Yesno}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          if (res.Data.length > 0) {
            this.loadings = false;
            this.Counts = Number(res.Counts);
            this.tableData = res.Data;
            this.serialnumber = true;
          } else {
            this.serialnumber = false;
            this.loadings = false;
          }
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
  },
  mounted() {
    this.$Http_Post('ScaleIssue/GetShowScaleTwo').then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.options = res.Data;
      }
    })

    this.$Http_Post('EmphasisClarification/GetSubjectPublish').then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        if (res.Data.length > 0) {
          this.PublishSubject = res.Data;
          this.formInline.PublishID = res.Data[0].PublishID;
          this.xaxa = res.Data[0].PublishID;
          this.schange(res.Data[0].PublishID);
          this.loading(1, 0);
        } else {
          this.loading(1, 0);
        }
      }
    })
  },
}
</script>
<style>
.Outdata .el-tabs__nav-scroll {
  border: 1px solid #e3e3e3;
  padding-left: 16px;
}
.Outdata .el-tabs__header {
  margin: 0 0 0px;
}
input {
  width: 300px;
}
.Outdata .el-form--inline .el-form-item {
  width: 31.5%;
}
.Outdata .el-form-item__content {
  width: 75%;
  height: 36px;
  line-height: 36px;
}
.Outdata .el-select {
  width: 75%;
}
.Outdata .el-form-item__label {
  width: 70px;
  text-align: right;
}
.Outdata .el-date-editor {
  width: 100%;
}
.Outdata .cvde {
  width: 60% !important;
}
.Outdata .cvde2 {
  width: 100% !important;
}
.Outdata .cvde2 .el-form-item__content {
  width: 90% !important;
}
.Outdata .el-form-item {
  margin-bottom: 10px;
}
.Outdata .Nac {
  height: 220px !important;
  position: relative;
  border: 1px solid #e3e3e3;
  padding-top: 20px;
  padding: 16px;
  background-color: white !important;
}
.Outdata .Nac2 {
  height: 300px;
  position: relative;
  border: 1px solid #e3e3e3;
  padding-top: 20px;
  padding: 16px;
}
.Outdata .el-input__inner {
  height: 36px;
  line-height: 36px;
}
.Outdata .change {
  width: 40px;
  margin-left: -80px;
  display: inline-block;
  height: 22px;
  margin-top: 22px;
  position: absolute;
  z-index: 10;
  cursor: pointer;
  color: #5e5a5a;
}
.Outdata .cvbb {
  margin-bottom: 30px;
}
.Outdata .Thelist {
  padding: 16px;
  background-color: #fff;
  border: 1px solid #e3e3e3;
  margin-top: 15px;
}
.Outdata .el-tooltip__popper {
  max-width: 20%;
}
.Outdata .el-tooltip__popper,
.Outdata .el-tooltip__popper.is-dark {
  background: #f5f5f5 !important;
  color: #303133 !important;
}
.Outdata .el-cascader {
  width: 100%;
}

.Outdata .block {
  margin-top: 10px !important;float: right;
}
.Outdata .el-checkbox {
  margin-right: 10px !important;
}

.CommonContentSingle-gray .el-table__empty-block{width: 100% !important;}
</style>
